import { MapLine } from "../interfaces/map-line";

export const drawLineOnMap = (map: mapboxgl.Map, line: MapLine, color?: string) => {
    const sourceId = line.identification + '-source';
    const layerId = line.identification + '-layer';

    const coords = line.coordinates.map(x => x.coordinate);
    const source: any = {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': [
                {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'LineString',
                        'properties': {},
                        'coordinates': coords
                    }
                }
            ]
        }
    }
    map.addSource(sourceId, source);

    const layer: mapboxgl.AnyLayer = {
        'id': layerId,
        'type': 'line',
        'source': sourceId,
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
        'paint': {
            'line-color': color ? color : (line.color ?? '#00ac11'),
            'line-width': 5
        }
    }

    map.addLayer(layer);
}

export const deleteLine = (map: mapboxgl.Map, identification: string) => {
    const sourceId = identification + '-source';
    const layerId = identification + '-layer';

    if (map.getLayer(layerId)) {
        map.removeLayer(layerId);
    }

    if (map.getSource(sourceId)) {
        map.removeSource(sourceId);
    }
}